<template>
  <v-footer style="background-color:rgb(245, 245, 249) !important;" padless>
    <v-row justify="center" no-gutters>
        <v-col class=" lighten-2 py-4 text-center " cols="12">
            © {{ new Date().getFullYear() }} E3Mobility inc. All rights reserved.
        </v-col>
    </v-row>
  </v-footer>
</template>

<script>
  export default {
    name: 'Footer',
  }
</script>